import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Refine Text Panel Config"})
export default class RefineTextPanelConfig {

	@Input({type: InputType.TEXT, title: "Query Paramter"})
	public paramName: string;

	@Input({type: InputType.CHECKBOX, title: "Auto Submit While Typing (debounced)"})
	public autoSubmit: boolean;

	@Input({type: InputType.TEXT, title: "Placeholder Text"})
	public placeholder: string;

	@Input({type: InputType.CHECKBOX, title: "Show Button Labels"})
	public buttonLabels?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/refineText/RefineTextPanelConfig.ts